jQuery(function($) {
  const DURATION = 1500;
  const EASING = t => 1 - Math.pow(1 - t, 3);

  function wrapNumber(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const match = node.textContent.match(/\d+(?:[.,]\d+)?/);
      if (!match) continue;

      const before = node.textContent.slice(0, match.index);
      const after  = node.textContent.slice(match.index + match[0].length);
      const isFloat = match[0].includes('.') || match[0].includes(',');
      const decimalChar = match[0].includes(',') ? ',' : '.';

      const $span = $('<span>')
        .attr('data-counter-target', match[0].replace(',', '.'))
        .attr('data-counter-float', isFloat ? '1' : '')
        .attr('data-counter-decimal', decimalChar)
        .text(isFloat ? '0' + decimalChar + '0' : '0');

      const parent = node.parentNode;
      parent.insertBefore(document.createTextNode(before), node);
      parent.insertBefore($span[0], node);
      parent.insertBefore(document.createTextNode(after), node);
      parent.removeChild(node);

      return $span[0];
    }
    return null;
  }

  function animateCounter(el) {
    const span = $(el).find('[data-counter-target]')[0];
    if (!span) return;

    const target  = parseFloat(span.dataset.counterTarget);
    const isFloat = !!span.dataset.counterFloat;
    const decChar = span.dataset.counterDecimal;
    const start   = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / DURATION, 1);
      const current  = EASING(progress) * target;

      span.textContent = isFloat
        ? current.toFixed(1).replace('.', decChar)
        : Math.floor(current).toString();

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        span.textContent = isFloat
          ? target.toFixed(1).replace('.', decChar)
          : target.toString();
      }
    }

    requestAnimationFrame(tick);
  }

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -300px 0px', threshold: 0 }
  );

  $('.js-counter').each(function() {
    wrapNumber(this);
    observer.observe(this);
  });
});
